import {useParams} from 'react-router-dom';
import {useContext} from 'react';
import {NavigationContext, PortalDropdownsContext, UserContext} from '../../../providers';
import {useMemo} from 'react';

export const useNavigation = () => {
  const {isUserAdmin, isUserContributor, logout} = useContext(UserContext);
  const {favUnit} = useContext(PortalDropdownsContext);
  const {showChatbot, setShowChatbot, hideIcon, setHideIcon} = useContext(NavigationContext);
  const {unitId} = useParams();

  return useMemo(
    () => ({
      isUserAdmin,
      isUserContributor,
      isHomeUnitSelected: Boolean(favUnit),
      isHomeUnitCurrent: favUnit === unitId,
      favUnitUrl: `/unit/${favUnit}`,
      showChatbot,
      setShowChatbot,
      hideIcon,
      setHideIcon,
      logout
    }),
    [favUnit, isUserAdmin, unitId, isUserContributor, showChatbot, setShowChatbot, hideIcon, setHideIcon, logout]
  );
};
